"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CommentList = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _A11yContext = require("../../context/A11yContext");

var _CallbackContext = _interopRequireDefault(require("../../context/CallbackContext"));

var _constants = require("../../constants");

var _CommentListSection = _interopRequireDefault(require("./CommentListSection"));

var _BaseCommentList = _interopRequireDefault(require("./BaseCommentList"));

var _FilterEmptyState = _interopRequireDefault(require("../EmptyState/FilterEmptyState"));

var _OfflineEmptyState = _interopRequireDefault(require("../EmptyState/OfflineEmptyState"));

var _ErrorEmptyState = _interopRequireDefault(require("../EmptyState/ErrorEmptyState"));

var _Loading = _interopRequireDefault(require("./Loading"));

var _UnmappedTitle = _interopRequireDefault(require("./UnmappedTitle"));

var _CommentList = _interopRequireDefault(require("./CommentList.scss"));

var _useIngest = _interopRequireDefault(require("../../hooks/useIngest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CommentList = function CommentList(props) {
  var _classNames;

  var activeSectionInputFocused = props.activeSectionInputFocused,
      assetData = props.assetData,
      cacheComments = props.cacheComments,
      closeButtonClicked = props.closeButtonClicked,
      commentListMinimized = props.commentListMinimized,
      comments = props.comments,
      compactLayout = props.compactLayout,
      disableCommentCreation = props.disableCommentCreation,
      filter = props.filter,
      hasError = props.hasError,
      imsData = props.imsData,
      isFiltered = props.isFiltered,
      isLoading = props.isLoading,
      isOffline = props.isOffline,
      onHeightChange = props.onHeightChange,
      onShare = props.onShare,
      setUnmappedView = props.setUnmappedView,
      showAllScreenComments = props.showAllScreenComments,
      touchControls = props.touchControls,
      viewingUnmappedSection = props.viewingUnmappedSection;
  var validNodes = assetData.validNodes;
  var ccxIngest = (0, _useIngest.default)();

  var _useContext = (0, _react.useContext)(_CallbackContext.default),
      onNodeChange = _useContext.onNodeChange;

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      scrollTop = _useState2[0],
      setScrollTop = _useState2[1];

  var _useState3 = (0, _react.useState)(assetData.nodeId),
      _useState4 = _slicedToArray(_useState3, 2),
      activeNodeId = _useState4[0],
      setActiveNodeId = _useState4[1];

  var ref = (0, _react.useRef)();
  var handleScroll = (0, _react.useCallback)(function () {
    return setScrollTop(ref.current.scrollTop);
  }, []);
  var nodes = (0, _react.useMemo)(function () {
    if (validNodes) {
      var allNodes = validNodes.map(function (node) {
        return _objectSpread(_objectSpread({}, node), {}, {
          nodeId: node.id
        });
      });
      allNodes.push({
        id: _constants.UNMAPPED_GLOBAL_ID,
        nodeId: _constants.UNMAPPED_GLOBAL_ID,
        title: /*#__PURE__*/_react.default.createElement(_UnmappedTitle.default, null)
      });
      return allNodes;
    }

    return [];
  }, [validNodes]);
  /*
   * TODO: It re-memoizes the comments on node change or when reply button is toggled.
   *       Seems like `getFilteredComments` selector is returning a new array
   *       when it shouldn't and our selectors should be revisited in general.
   */

  var commentsByNodeId = (0, _react.useMemo)(function () {
    var nodeMap = nodes.reduce(function (map, _ref) {
      var nodeId = _ref.nodeId;
      map[nodeId] = [];
      return map;
    }, {});
    return comments.reduce(function (commentMap, comment) {
      if (comment.unmapped) {
        var _commentMap$UNMAPPED_;

        (_commentMap$UNMAPPED_ = commentMap[_constants.UNMAPPED_GLOBAL_ID]) === null || _commentMap$UNMAPPED_ === void 0 ? void 0 : _commentMap$UNMAPPED_.push(comment);
      } else {
        var _commentMap$_get;

        (_commentMap$_get = commentMap[(0, _lodash.default)(comment, 'target.selector.node.id')]) === null || _commentMap$_get === void 0 ? void 0 : _commentMap$_get.push(comment);
      }

      return commentMap;
    }, nodeMap);
  }, [comments, nodes]);
  var sectionRefs = (0, _react.useMemo)(function () {
    return nodes.reduce(function (refs, node) {
      refs[node.nodeId] = /*#__PURE__*/(0, _react.createRef)();
      return refs;
    }, {});
  }, [nodes]);
  (0, _react.useEffect)(function () {
    var sectionRef = sectionRefs[activeNodeId];

    if (isLoading || !sectionRef || !sectionRef.current || isFiltered) {
      return;
    }

    ref.current.scrollTop = sectionRef.current.offsetTop;
  }, [activeNodeId, isFiltered, isLoading, sectionRefs, showAllScreenComments]);
  var handleSectionClick = (0, _react.useCallback)(function (nodeId) {
    if (nodeId === _constants.UNMAPPED_GLOBAL_ID) {
      setUnmappedView(true);
    } else {
      setUnmappedView(false);
      onNodeChange(nodeId);
    }

    ccxIngest.fireEvent({
      event: {
        subcategory: 'navigation',
        subtype: 'switch-active-artboard',
        type: 'click'
      }
    });
  }, [ccxIngest, onNodeChange, setUnmappedView]);
  var handleSectionHeaderClick = (0, _react.useCallback)(function () {
    ref.current.scrollTop = sectionRefs[activeNodeId].current.offsetTop;
  }, [activeNodeId, sectionRefs]);

  if (isOffline && (isLoading || hasError)) {
    return /*#__PURE__*/_react.default.createElement(_OfflineEmptyState.default, null);
  }

  if (isLoading) {
    return /*#__PURE__*/_react.default.createElement(_Loading.default, {
      testId: "loading"
    }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
      id: "comments.list.loading"
    }));
  }

  if (hasError) {
    return /*#__PURE__*/_react.default.createElement(_ErrorEmptyState.default, null);
  }

  if (isFiltered && comments.length === 0) {
    return /*#__PURE__*/_react.default.createElement(_FilterEmptyState.default, null);
  }

  var className = (0, _classnames.default)(_CommentList.default.component, (_classNames = {}, _defineProperty(_classNames, _CommentList.default.minimized, commentListMinimized), _defineProperty(_classNames, _CommentList.default.compactInputFocused, activeSectionInputFocused), _classNames));
  var isSingleNode = nodes.filter(function (node) {
    return node.id !== _constants.UNMAPPED_GLOBAL_ID;
  }).length === 1;
  return /*#__PURE__*/_react.default.createElement("div", {
    "aria-labelledby": "comment-list-heading",
    ref: ref,
    id: _constants.LIST_COMPONENT_ID,
    className: className,
    onScroll: handleScroll
  }, /*#__PURE__*/_react.default.createElement("h2", {
    id: "comment-list-heading",
    className: "visually-hidden"
  }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
    id: "comments.sections.commentList"
  })), showAllScreenComments && comments.length ? /*#__PURE__*/_react.default.createElement(_A11yContext.A11yProvider, null, nodes.map(function (_ref2) {
    var nodeId = _ref2.nodeId,
        title = _ref2.title,
        subtitle = _ref2.subtitle;
    return /*#__PURE__*/_react.default.createElement(_CommentListSection.default, {
      key: nodeId,
      ref: sectionRefs[nodeId],
      compactCommentingMode: activeSectionInputFocused,
      disableActiveStyling: isSingleNode,
      hideHeader: isSingleNode && nodeId !== _constants.UNMAPPED_GLOBAL_ID,
      id: "section--".concat(nodeId),
      isActive: viewingUnmappedSection ? nodeId === _constants.UNMAPPED_GLOBAL_ID : nodeId === assetData.nodeId,
      isEmpty: commentsByNodeId[nodeId].length === 0,
      nodeId: nodeId,
      onActiveSectionChange: setActiveNodeId,
      onActiveSectionHeaderClick: handleSectionHeaderClick,
      onInactiveSectionClick: handleSectionClick,
      scrollTop: scrollTop,
      subtitle: subtitle,
      title: title
    }, /*#__PURE__*/_react.default.createElement(_BaseCommentList.default, {
      ariaLabelledBy: "section--".concat(nodeId),
      assetData: assetData,
      cacheComments: cacheComments,
      closeButtonClicked: closeButtonClicked,
      comments: commentsByNodeId[nodeId],
      compactLayout: compactLayout,
      emptyStateType: "global",
      filter: filter,
      imsData: imsData,
      isFiltered: isFiltered,
      isOffline: isOffline,
      onHeightChange: onHeightChange,
      onShare: onShare,
      touchControls: touchControls
    }));
  })) : /*#__PURE__*/_react.default.createElement(_BaseCommentList.default, {
    assetData: assetData,
    cacheComments: cacheComments,
    closeButtonClicked: closeButtonClicked,
    comments: comments,
    compactLayout: compactLayout,
    emptyStateType: disableCommentCreation ? 'disabledCommentCreation' : 'normal',
    filter: filter,
    imsData: imsData,
    isFiltered: isFiltered,
    isOffline: isOffline,
    onHeightChange: onHeightChange,
    onShare: onShare,
    touchControls: touchControls
  }));
};

exports.CommentList = CommentList;
CommentList.defaultProps = {
  setUnmappedView: function setUnmappedView() {}
};
CommentList.propTypes = {
  activeSectionInputFocused: _propTypes.default.bool,
  assetData: _propTypes.default.object,
  cacheComments: _propTypes.default.bool,
  children: _propTypes.default.func,
  closeButtonClicked: _propTypes.default.bool,
  commentListMinimized: _propTypes.default.bool,
  comments: _propTypes.default.array,
  compactLayout: _propTypes.default.bool,
  disableCommentCreation: _propTypes.default.bool,
  filter: _propTypes.default.string,
  guestLoginToast: _propTypes.default.object,
  hasError: _propTypes.default.bool,
  imsData: _propTypes.default.object,
  intl: _propTypes.default.object,
  isFiltered: _propTypes.default.bool,
  isLoading: _propTypes.default.bool,
  isOffline: _propTypes.default.bool,
  onHeightChange: _propTypes.default.func,
  onShare: _propTypes.default.func,
  scrollToTop: _propTypes.default.bool,
  setUnmappedView: _propTypes.default.func,
  showAllScreenComments: _propTypes.default.bool,
  touchControls: _propTypes.default.bool,
  viewingUnmappedSection: _propTypes.default.bool
};
var _default = CommentList;
exports.default = _default;